import { apiClient } from '@indipia/shared';

export interface LoginTokens {
  accessToken: string;
  refreshToken: string;
  userId: number;
  loginId: string;
  userName: string;
  roles: string[];
  compId: number;
}

/** 아이디/비밀번호 로그인 — POST /gatepass/login */
export async function loginWithIdPassword(loginId: string, password: string): Promise<LoginTokens> {
  const res = await apiClient.post('/gatepass/login', { loginId, password });
  return res.data.data as LoginTokens;
}
